import React from "react";
import { getMobileDownloadButtonValues } from "../globalConstants";
import { trackDownloadClick, CtaPlacement } from "../analytics/events";


interface DownloadButtonsMobileProps {
    style?: React.CSSProperties
    shadowOn?: boolean
    /** Which section this instance sits in, reported with the GA4 download_click event. */
    placement?: CtaPlacement
}


export const DownloadButtonsMobile: React.FC<DownloadButtonsMobileProps> = ({ style = {}, shadowOn = true, placement = "unknown" }) => {
    return (
        <img
            src={getMobileDownloadButtonValues().source}
            style={{

                width: "75%",
                objectFit: "contain",
                borderRadius: "15px", // Added border radius for rounded corners
                boxShadow: shadowOn ? "0px 0px 10px 3px white" : null, // Added fading shadow,

                ...style
            }}
            alt=""
            onClick={() => {
                const link = getMobileDownloadButtonValues().link;
                trackDownloadClick(link, placement);
                window.open(link);
            }}
        />
    )

}